<template>
  <form-button-group
    align="right"
    class="cordel-filters-buttons"
    :mobile="sdk.mobile"
  >
    <form-button
      :color="color"
      :icon="icon"
      @click="toggle"
    >
      {{ label }}
    </form-button>
  </form-button-group>
</template>

<script>
  import mobile from '@sdk/helpers/interface/mobile';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  export default {
    name: 'CordelFiltersButton',
    components: {
      FormButton,
      FormButtonGroup,
    },
    mixins: [
      mobile,
    ],
    props: {
      active: {
        type: Boolean,
        default: false,
      },
      action: {
        type: String,
        default: null,
      },
    },
    computed: {
      color() {
        return this.active ? 'danger' : 'secondary';
      },
      icon() {
        return this.active ? 'undo' : 'filter';
      },
      label() {
        return this.active ? 'Limpar filtros' : 'Filtros';
      },
    },
    methods: {
      toggle() {
        this.$store.dispatch(this.action, {
          _active: !this.active,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-filters-buttons {
  }
</style>
